import React from 'react';
import Typography from '@visa/vds/typography';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import MCSSpace from '../../components/MCSSpace';
import PagePic from '../../_imgs/illustrations/scene/illustration-scene-inspector-blue-beard.svg';
function AccessDenied() {
    return (
      <Grid>
        <MCSSpace height="50px" />
        <Typography style={{textAlign:"center",margin:"auto"}} tag="h1">Access Denied</Typography>
        <MCSSpace />
        <img style={{ width: "235px", margin:"auto" }} src={PagePic}/>
        <MCSSpace />
        <Row>
          <Col textAlign={"center"}>
            <Typography tag="h4">Your Access Request may be pending approval or has been revoked.</Typography>
            <Typography tag="h4">Please contact 3DS Admin team for enquiry.</Typography>
          </Col>
        </Row>
      </Grid>
    );
  }

export default AccessDenied;
